import { createSumArray } from "./createSumArray"

export const getFreightInfoTotals = (freightInfoTotals, freightInfo, freightInfoUOM) => {
    let arrayOfQty = []
    let arrayOfWeight = freightInfo?.map(freight => {
        if(freight.each === 'Each' || !freight.each){
            return Number(freight.weight) * Number(freight.qty)
        }else{
            return freight.weight
        }
    })
    let arrayOfCFT = []
    let finalQty, finalWeight, finalCFT

    freightInfo?.forEach(object => {
        if (object.qty) {
            arrayOfQty.push(parseInt(object.qty))
        }

        let QTY = parseInt(object.qty);
        let L = parseFloat(object.L);
        let W = parseFloat(object.W);
        let H = parseFloat(object.H);
        let cubic = L * W * H;

        if (freightInfoUOM.value !== 'US') {
            cubic /= 1000000; // m3
        } else {
            cubic /= 1728; // ft3
        }

        arrayOfCFT?.push(cubic * ((object.each === 'Each' || !object.each) ? QTY : 1))
    })

    finalCFT = createSumArray(arrayOfCFT)
    finalQty = createSumArray(arrayOfQty)
    finalWeight = createSumArray(arrayOfWeight)

    return {
        ...freightInfoTotals,
        totalPieces: finalQty || 0,
        totalWeight: finalWeight || 0,
        totalCFT: finalCFT || 0,
        totalDensity:
        (finalWeight / finalCFT) === Number.POSITIVE_INFINITY || isNaN(finalWeight / finalCFT)
            ? 0 
            : (
                isNaN(finalCFT)
                ? 0
                : Math.round(((freightInfoUOM.value === 'US' ? (finalWeight / finalCFT) : ((finalWeight * 2.20462262) / (finalCFT * 35.3107344632768))) * 100)) / 100
            )
    }
}